import { version } from '../../../package.json';
import { cn } from '@utils/cn';

export const Footer = ({ isCompact }: { isCompact?: boolean }) => (
  <footer
    className={cn(
      'footer t-auto flex flex-wrap items-center py-2.5 ',
      isCompact ? 'mx-auto mb-auto w-full max-w-md flex-col' : 'mx-auto w-full px-4',
    )}>
    <div className="mb-2.5 w-full border-t border-neutral-200" />
    <div className={cn('flex flex-1 items-center gap-5', isCompact && 'flex-col')}>
      <img className="h-4 w-auto" src="/logo.png" />
      <span
        className={cn(
          'flex flex-1 justify-between font-inter font-semibold text-neutral-400',
          isCompact && 'flex-col items-center',
        )}>
        <span>© 2025 Retti, Inc.</span>
        <span>v{version}</span>
      </span>
    </div>
  </footer>
);
